import script from "./AppSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSidebar.vue?vue&type=script&setup=true&lang=js"

import "./AppSidebar.vue?vue&type=style&index=0&id=557059e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-557059e0"]])

export default __exports__